/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyFormData
 */
export interface AgencyFormData {
    /**
     * 
     * @type {string}
     * @memberof AgencyFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {object}
     * @memberof AgencyFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AgencyFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyFormData
     */
    abtaNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyFormData
     */
    label?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AgencyFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AgencyFormData
     */
    group?: GuidIdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyFormData
     */
    disabled?: boolean;
}

export function AgencyFormDataFromJSON(json: any): AgencyFormData {
    return AgencyFormDataFromJSONTyped(json, false);
}

export function AgencyFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'abtaNumber': !exists(json, 'abtaNumber') ? undefined : json['abtaNumber'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'group': !exists(json, 'group') ? undefined : GuidIdAndLabelFromJSON(json['group']),
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function AgencyFormDataToJSON(value?: AgencyFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'abtaNumber': value.abtaNumber,
        'label': value.label,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'group': GuidIdAndLabelToJSON(value.group),
        'disabled': value.disabled,
    };
}


